<template>
  <img :src="image.path | image(imageDimensions)" :style="animationStyle" class="img-fluid">
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    image: {
      type: Object,
      default: null
    },
    animate: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    }
  },
  computed: {
    imageDimensions () {
      let str = ''
      if (this.width) {
        str = Number.parseInt(this.width)
      }
      str += 'x'
      if (this.height) {
        str += Number.parseInt(this.height)
      }
      return str
    },
    animationStyle () {
      if (!this.animation) {
        return {}
      }
      const style = {
        transition: 'all ' + this.animation.duration + 's linear'
      }
      if (this.animate) {
        return {
          ...style,
          transform: 'translateX(' + this.animation.translate_x + '%) translateY(' + this.animation.translate_y + '%) scale(' + this.animation.scale + ')'
        }
      }

      return style
    },
    animation () {
      return this.animations.find(a => a.id === this.image.animation_id)
    },
    ...mapGetters({
      animations: 'configurator/animations'
    })
  }
}
</script>
